import React from "react";

import { TableHeaderProps } from ".";

export interface ColumnsProps {
  headers: ReadonlyArray<TableHeaderProps>;
}

const Columns: React.FC<ColumnsProps> = ({ headers }: ColumnsProps): JSX.Element => {
  const columns = headers.map(({ key, label, className, testID, additionalDOMAttributes }) => {
    return (
      <th {...additionalDOMAttributes} key={key} scope="col" className={className} data-testid={testID}>
        {label}
      </th>
    );
  });

  return <tr>{columns}</tr>;
};

export default Columns;
